import {all} from "redux-saga/effects";
import userSagas from "@fkhplus/common/src/modules/user/saga";
import watchThemeSagas from "@fkhplus/common/src/modules/theme/saga";
import watchNetworkSagas from "@fkhplus/common/src/modules/network/saga";

export function* rootSaga(): Generator {
    yield all([
        userSagas(),
        watchThemeSagas(),
        watchNetworkSagas()
    ])
}
